export default "__VITE_ASSET__bae71b35__"